export const extractTokenUsage = (payload) => {
  if (!payload || typeof payload !== "object") return null;

  const raw =
    payload.token_usage ||
    payload.result?.token_usage ||
    payload.fastapi_response?.token_usage ||
    payload.body?.token_usage ||
    null;

  if (!raw || typeof raw !== "object") return null;

  return {
    query_count: Number(raw.query_count ?? raw.queryCount ?? 0) || 0,
    prompt_tokens: Number(raw.prompt_tokens ?? raw.promptTokens ?? 0) || 0,
    session_output_tokens:
      Number(raw.session_output_tokens ?? raw.sessionOutputTokens ?? 0) || 0,
    total_tokens: Number(raw.total_tokens ?? raw.totalTokens ?? 0) || 0,
    limit: Number(raw.limit ?? 0) || 0,
    blocked: raw.blocked === true || String(raw.blocked || "").toLowerCase() === "true",
  };
};

export const isSessionLimitReached = (tokenUsage) => {
  if (!tokenUsage || typeof tokenUsage !== "object") return false;

  const total = Number(tokenUsage.total_tokens ?? 0);
  const limit = Number(tokenUsage.limit ?? 0);
  return tokenUsage.blocked === true || (limit > 0 && total >= limit);
};

export const tokenUsageMatches = (tokenUsageA, tokenUsageB) => {
  if (!tokenUsageA || !tokenUsageB) return false;
  return (
    Number(tokenUsageA.total_tokens || 0) === Number(tokenUsageB.total_tokens || 0) &&
    Number(tokenUsageA.limit || 0) === Number(tokenUsageB.limit || 0) &&
    Boolean(tokenUsageA.blocked) === Boolean(tokenUsageB.blocked)
  );
};

export const isSessionLimitError = (payload) => {
  if (!payload) return false;

  const checkText = (text) => {
    if (!text || typeof text !== "string") return false;
    const lower = text.toLowerCase();
    return (
      lower.includes("session budget exceeded") ||
      lower.includes("session limit reached") ||
      text.toUpperCase().includes("SESSION_LIMIT_REACHED")
    );
  };

  // Handle string payload
  if (typeof payload === "string") return checkText(payload);

  if (typeof payload !== "object") return false;

  // Check common error fields
  if (payload.error === "SESSION_LIMIT_REACHED") return true;

  const fieldsToCheck = [
    payload.message,
    payload.error,
    payload.detail,
    payload.result?.message,
    payload.fastapi_response?.message,
    payload.fastapi_response?.error,
  ];

  for (const field of fieldsToCheck) {
    if (typeof field === "string" && checkText(field)) return true;
    if (typeof field === "object" && isSessionLimitError(field)) return true;
  }

  return false;
};

export const getSessionLimitMessage = (payload) => {
  const defaultMsg = "Session limit reached. Please start a new session to continue.";
  if (!payload) return defaultMsg;

  if (typeof payload === "string") {
    return payload.toLowerCase().includes("budget")
      ? "Session limit reached. Please start a new session to continue."
      : payload;
  }

  const msg = payload.message || payload?.result?.message || payload?.error;
  if (typeof msg === "string" && msg.trim()) return msg;

  // Specific check for budget in any field
  const rawText = JSON.stringify(payload).toLowerCase();
  if (rawText.includes("budget exceeded")) {
    return "Session limit reached. Please start a new session to continue.";
  }

  return defaultMsg;
};
